/**
 * Metadati <head> dell'area Visite. Lo script inline di public/index.html li applica
 * prima del primo paint quando si apre direttamente /visite*; questa funzione li
 * applica (e li ripristina) quando si entra navigando dentro la SPA.
 * I valori devono coincidere con quelli dello script inline (c'è un test).
 */
export const VISITE_MANIFEST = "/visite/manifest.webmanifest";
export const VISITE_VIEWPORT = "width=device-width, initial-scale=1, viewport-fit=cover";
export const VISITE_THEME_LIGHT = "#f4f7f4";
export const VISITE_THEME_DARK = "#121816";
export const VISITE_APPLE_ICON = "/visite/icons/visite-apple-touch-180.png";
export const VISITE_TITLE = "Visite";

export function isVisitePath(p) {
  return p === "/visite" || String(p || "").startsWith("/visite/") || p === "/visite-login";
}

function setAttr(sel, attr, val, saved) {
  const el = document.head.querySelector(sel);
  if (!el) return;
  saved.push([el, attr, el.getAttribute(attr)]);
  el.setAttribute(attr, val);
}

/** Applica i metadati Visite; restituisce una funzione che ripristina quelli originali. */
export function applyVisiteHead() {
  if (typeof document === "undefined") return () => {};
  if (document.documentElement.getAttribute("data-app") === "visite" && document.head.querySelector('meta[data-visite="1"]')) {
    return () => {};
  }
  const saved = [];
  setAttr('link[rel="manifest"]', "href", VISITE_MANIFEST, saved);
  setAttr('meta[name="viewport"]', "content", VISITE_VIEWPORT, saved);
  setAttr('meta[name="theme-color"]', "content", VISITE_THEME_LIGHT, saved);
  setAttr('meta[name="theme-color"]', "media", "(prefers-color-scheme: light)", saved);
  setAttr('meta[name="apple-mobile-web-app-title"]', "content", VISITE_TITLE, saved);
  setAttr('meta[name="application-name"]', "content", VISITE_TITLE, saved);
  setAttr('link[rel="apple-touch-icon"]', "href", VISITE_APPLE_ICON, saved);
  const dark = document.createElement("meta");
  dark.name = "theme-color";
  dark.content = VISITE_THEME_DARK;
  dark.setAttribute("media", "(prefers-color-scheme: dark)");
  dark.setAttribute("data-visite", "spa");
  document.head.appendChild(dark);
  document.documentElement.setAttribute("data-app", "visite");
  return () => {
    for (let i = saved.length - 1; i >= 0; i -= 1) {
      const [el, attr, val] = saved[i];
      if (val === null) el.removeAttribute(attr);
      else el.setAttribute(attr, val);
    }
    dark.remove();
    document.documentElement.removeAttribute("data-app");
  };
}
